// Maps an app language code to a BCP-47 tag for locale-aware Intl formatting
// (weekday / month names in the current language). fr → fr-FR keeps every
// existing French date string byte-identical.
export function localeTag(lng: string): string {
  switch (lng) {
    case 'fr': return 'fr-FR';
    case 'en': return 'en-GB';
    case 'zh': return 'zh-CN';
    case 'ja': return 'ja-JP';
    case 'ar': return 'ar';
    default: return 'fr-FR';
  }
}
